import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import AccountDropdown from './AccountDropdown';
import { useAuth } from '../../contexts/AuthContext';

const MainNavigation = ({ isAuthenticated = false, user = null }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { isAdmin } = useAuth();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location?.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const allNavigationItems = [
  { label: 'Home', path: '/home-page', icon: 'Home' },
  { label: 'Browse Trailers', path: '/search-results', icon: 'Search' },
  { label: 'Messages', path: '/messaging-center', icon: 'MessageSquare', requiresAuth: true },
  { label: 'List Your Trailer', path: '/trailer-listing-creation', icon: 'Plus' },
  { label: 'Admin Platform Management', path: '/admin-platform-management', icon: 'Shield', requiresAdmin: true },
  { label: 'Admin Settings', path: '/admin-settings', icon: 'Sliders', requiresAdmin: true }];

  // Filter navigation items based on authentication status and admin role
  const navigationItems = allNavigationItems?.filter(item => {
    if (item?.requiresAuth && !isAuthenticated) return false;
    if (item?.requiresAdmin && !isAdmin) return false;
    return true;
  });


  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 bg-card shadow-elevation-2 z-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center">
              <Link to="/home-page" className="flex items-center space-x-3 transition-smooth hover:opacity-80">
                <img 
                  src="/assets/images/ChatGPT_Image_Feb_3_2026_04_58_59_PM-1770675660365.png" 
                  alt="Draggin Trailers Logo" 
                  className="w-12 h-12 object-contain rounded-md"
                />
                <span className="font-heading font-bold text-xl text-foreground">Draggin Trailers</span>
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-1">
              {navigationItems?.map((item) =>
              <Link
                key={item?.path}
                to={item?.path}
                className={`flex items-center space-x-2 px-6 py-3 rounded-md font-body font-medium transition-smooth ${
                isActivePath(item?.path) ?
                'bg-primary text-primary-foreground' :
                'text-foreground hover:bg-muted'}`
                }>

                  <Icon name={item?.icon} size={20} strokeWidth={2} />
                  <span>{item?.label}</span>
                </Link>
              )}
            </div>

            <div className="hidden md:flex items-center space-x-4">
              <AccountDropdown isAuthenticated={isAuthenticated} user={user} />
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-foreground hover:bg-muted transition-smooth focus:outline-none focus-ring"
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}>

              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} strokeWidth={2} />
            </button>
          </div>
        </div>
      </nav>
      {isMobileMenuOpen &&
      <div className="fixed inset-0 z-dropdown md:hidden">
          <div className="fixed inset-0 bg-background" onClick={() => setIsMobileMenuOpen(false)} />
          <div className="fixed top-20 left-0 right-0 bottom-0 bg-card shadow-elevation-5 overflow-y-auto">
            <div className="px-4 py-6 space-y-2">
              {navigationItems?.map((item) =>
            <Link
              key={item?.path}
              to={item?.path}
              className={`flex items-center space-x-3 px-6 py-4 rounded-md font-body font-medium transition-smooth ${
              isActivePath(item?.path) ?
              'bg-primary text-primary-foreground' :
              'text-foreground hover:bg-muted'}`
              }>

                  <Icon name={item?.icon} size={22} strokeWidth={2} />
                  <span className="text-lg">{item?.label}</span>
                </Link>
            )}
              <a
                href="/dispute-resolution"
                className="block px-4 py-2 text-sm text-foreground hover:bg-muted transition-smooth"
              >
                Disputes
              </a>
              <a
                href="/owner-dispute-review"
                className="block px-4 py-2 text-sm text-foreground hover:bg-muted transition-smooth"
              >
                Review Disputes
              </a>
              
              <div className="pt-4 border-t border-border">
                <AccountDropdown isAuthenticated={isAuthenticated} user={user} isMobile={true} />
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );

};

export default MainNavigation;